export { default as useScreen } from './useScreen';
export * from './useScreen';
//# sourceMappingURL=index.js.map